if (!customElements.get('infinity-slider')) {
  class InfinitySlider extends HTMLElement {
    constructor() {
      super();
      this.setupThemenseitenSliderMobile();
      this.setupReviewsSlider();
    }

    setupThemenseitenSliderMobile() {
      if (screen.width < 901 && this.hasAttribute('data-themenseiten-slider')) {
        this.initializeElements();
        this.initializeState();
        this.setBasePosition();
        this.addEventListeners();
      }
    }

    setupReviewsSlider() {
      if (this.hasAttribute('data-reviews-slider')) {
        this.initializeElements();
        this.initializeState();
        this.setBasePosition();
        this.addEventListeners();
        this.setAutoMoveSlider();
      }
    }

    // Initializes DOM elements and calculates slide width
    initializeElements() {
      this.track = this.querySelector('[data-slider-track]');
      this.swipeArea = this.querySelector('[data-swipe]')
      this.cloneTrack = this.track.cloneNode(true); // Clone track for infinite effect
      this.slideWidth = this.track.firstElementChild.getBoundingClientRect().width;
      console.log(this.track.firstElementChild.firstElementChild.getBoundingClientRect().height)
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');
      this.maxIndex = this.track.children.length - 1;
    }

    // Initializes the slider's state
    initializeState() {
      this.currentSlide = 0;
      this.currentIndex = 0;

      this.swipeStartX = 0;

      this.autoMoveInterval = null;
      this.state = this.hasAttribute('data-move') || false;
    }

    // Setup events listeners

    addEventListeners() {
      // Adds click event listeners for navigation buttons
      this.prev.addEventListener('click', () => this.moveToSlide('prev'));
      this.next.addEventListener('click', () => this.moveToSlide('next'));

      // Check if swipe area exists
      if (this.swipeArea) {
        // Initialize swipe event listeners
        this.handleSwipe();
      }
    }

    handleSwipe() {
      this.swipeArea.addEventListener('touchstart', (e) => {
        this.state = false;
        this.swipeStartX = Math.round(e.touches[0].clientX);
      });

      this.swipeArea.addEventListener('touchmove', (e) => {
        this.swipeMoveX = Math.round(e.touches[0].clientX);
      });

      this.swipeArea.addEventListener('touchend', (e) => {
        let swipeEndX = Math.round(e.changedTouches[0].clientX);
        let swipeDistance = this.swipeStartX - swipeEndX;

        // Define a threshold to prevent accidental swipes
        const swipeThreshold = 30;
        if (swipeDistance > swipeThreshold) {
          this.moveToSlide('next');
        } else if (swipeDistance < -swipeThreshold) {
          this.moveToSlide('prev');
        }
      });
    }

    // Handles slide navigation and sets up the infinite effect
    moveToSlide(direction) {
      this.state = false;
      if (direction === 'next') {
        this.currentSlide++;
        this.handleMoveSlider(direction);
        this.currentIndex++;
        this.currentIndex = this.setupInfinityLoop(this.currentIndex);
      } else {
        this.currentSlide--;
        this.currentIndex--;
        this.currentIndex = this.setupInfinityLoop(this.currentIndex);
        this.handleMoveSlider(direction);
      }
    }

    // Moves the slider to the current slide position
    handleMoveSlider(direction) {
      this.track.style.transform = `translate3d(${(-this.currentSlide * this.slideWidth)}px, 0, 0)`;
      this.updateItems(direction);
    }

    // Clones and appends/prepends items to create infinite scrolling effect
    updateItems(direction) {
      const cloneSlide = [...this.cloneTrack.children][this.currentIndex].cloneNode(true);
      if (direction === 'next') {
        this.appendCloneSlide(cloneSlide);
      } else {
        this.prependCloneSlide(cloneSlide);
      }
    }

    // Appends a cloned slide and removes the first element
    appendCloneSlide(cloneSlide) {
      cloneSlide.style.transform = `translate3d(${((this.maxIndex + this.currentSlide) * this.slideWidth)}px, 0, 0)`;
      this.track.append(cloneSlide);
      setTimeout(() => this.track.firstElementChild.remove(), 400);
    }

    // Prepends a cloned slide and removes the last element
    prependCloneSlide(cloneSlide) {
      cloneSlide.style.transform = `translate3d(${(this.currentSlide * this.slideWidth)}px, 0, 0)`;
      this.track.prepend(cloneSlide);
      setTimeout(() => this.track.lastElementChild.remove(), 400);
    }

    // Positions each slide based on index for initial setup
    setBasePosition() {
      [...this.track.children].forEach((elem, index) => {
        elem.style.transform = `translate3d(${(this.slideWidth * index)}px, 0, 0)`;
      });
    }

    // Resets currentIndex within bounds for infinite loop effect
    setupInfinityLoop(currentIndex) {
      return currentIndex = (currentIndex + this.maxIndex + 1) % (this.maxIndex + 1);
    }


    setAutoMoveSlider() {
      if (this.autoMoveInterval) {
        clearInterval(this.autoMoveInterval);
      }

      this.autoMoveInterval = setInterval(() => {
        if (this.state) {
          this.currentSlide++;
          this.handleMoveSlider('next');
          this.currentIndex++;
          this.currentIndex = this.setupInfinityLoop(this.currentIndex);
        } else {
          clearInterval(this.autoMoveInterval);
        }
      }, parseInt(this.dataset.duration, 10) * 1000);
    }

  }

  customElements.define('infinity-slider', InfinitySlider);
}
